import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';
import ErrorHandler from '../Reusable/ErrorHandler';

class ModalForAddMunicipalityToPlace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      place: this.props.municipality?.place || null,
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    const { place } = this.state;
    const { Errors } = this.props.t || {};

    let errors = {};

    if (!place) {
      errors['place'] = Errors?.place;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const municipalityForUpdate = {
      ...this.props.municipality,
      place: this.state.place,
    };

    this.props.updateMunicipality(municipalityForUpdate);
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({
      place: newValue,
    });
  };

  render() {
    const { error, deleteError, t, placeList, municipality } = this.props || {},
      { Placeholders, Labels } = t || {},
      { place } = municipality || null;

    const titleModal = place ? Labels.titleUpdate : Labels.title;

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{titleModal}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <ComboBoxAutocomplete
                    data={placeList}
                    text={(place) => place.name}
                    changeValue={(newValue) =>
                      this.changeComboAutocompleteValue('place', newValue)
                    }
                    updateValue={this.state.place}
                    wholeObject
                    placeholder={Placeholders.place}
                    error={handleErrorMessage(
                      error,
                      'place',
                      this.state.errors.place
                    )}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddMunicipalityToPlace,
  'ModalForAddMunicipalityToPlace'
);
